import React, { useEffect, useState } from "react"
import { useAppDispatch } from "../../../store"
import { setCurrentPage } from "../../../store/auth/authReducer"
import LinearProgress from "@mui/material/LinearProgress"
import axios from "axios"
import { Link, useLocation } from "react-router-dom"
import Button from "@mui/material/Button"
import Box from "@mui/material/Box"
import { logOut } from "../../../utils/logOut"
import { Typography, Breadcrumbs, List, ListItem, ListItemButton, ListItemIcon, ListItemText, Dialog, DialogTitle, DialogContent, DialogActions, TextField, Paper, IconButton, Tooltip, FormControlLabel, Switch, FormControl, InputLabel, Select, MenuItem } from "@mui/material"
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline'
import EditOutlinedIcon from '@mui/icons-material/EditOutlined'
import FolderOutlinedIcon from '@mui/icons-material/FolderOutlined'
import FunctionsIcon from '@mui/icons-material/Functions'
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew'
import TranslatedText from "../../../utils/Translate"
import { useSnackbar } from "../../../utils/SnackbarContext"
import { access } from "fs"
import { useSelector } from "react-redux"
import { de } from "date-fns/locale"

export default function Functions() {
    const dispatch = useAppDispatch()
    const [folderData, setFolderData] = useState<any>({ parent: null, path: 'Root', access: false, edit: false, childs: [] })
    const [currentFolderId, setCurrentFolderId] = useState<number | null>(null)
    const [folderHistory, setFolderHistory] = useState<Array<{ id: number | null; title: string }>>([])
    const [loading, setLoading] = useState(false)
    const [createFolderOpen, setCreateFolderOpen] = useState(false)
    const [newFolder, setNewFolder] = useState({ name: '', description: '', showsetuptopartner: '1', partner: null })
    const [editFolderOpen, setEditFolderOpen] = useState(false)
    const [editFolderLoading, setEditFolderLoading] = useState(false)
    const [editFolder, setEditFolder] = useState({ name: '', description: '', path: '', showsetuptopartner: '1', partner: null })
    const [editingFolderId, setEditingFolderId] = useState<number | null>(null)
    const [partners, setPartners] = useState([])
    const [isInitialUrlLoad, setIsInitialUrlLoad] = useState(true)
    const [startedFromUrl, setStartedFromUrl] = useState(false)
    const location = useLocation()

    const { showSnackbar } = useSnackbar();

    useEffect(() => {
        dispatch(setCurrentPage(`Functions`))
    }, [dispatch]);

    const accesslevel = useSelector(
        (state: any) => state.auth.authData.accesslevel
    )

    //Get params from URL
    const params = new URLSearchParams(location.search);
    const folder_id = params.get('folder_id');

    //Auto-open folder from URL parameter
    useEffect(() => {
        if (folder_id && isInitialUrlLoad) {
            setCurrentFolderId(Number(folder_id))
            setFolderHistory([])
            setStartedFromUrl(true)
            setIsInitialUrlLoad(false)
        }
    }, [folder_id, isInitialUrlLoad])

    //Making request to get partners list
    async function getPartners(params: object = {}) {
        setLoading(true)
        try {
            const response = await axios.get(`https://cardgarantsales.com/restapi/partner`, {
                headers: {
                    'Content-Type': 'application/json',
                    "Authorization": "Bearer " + localStorage.getItem('access_token')
                }, params: params
            })
            console.log(response.data);
            setPartners(response.data)

            setLoading(false)
        } catch (error: any) {
            console.log(error);
            if (error.message === "Request failed with status code 401") {
                logOut(dispatch)
            }
            else if (error.code === "ERR_NETWORK") {
                showSnackbar('ERROR NETWORK', 'error')
            }
            setLoading(false)
        }
    }

    async function fetchData(folderId: number | null = null) {
        setLoading(true)
        try {
            const params = folderId != null ? { folder_id: folderId } : {}
            const response = await axios.get(`https://cardgarantsales.com/restapi/aifunctionsv2`, {
                headers: {
                    'Content-Type': 'application/json',
                    "Authorization": "Bearer " + localStorage.getItem('access_token')
                },
                params
            })

            if (response.data) {
                const result = response.data
                setFolderData({
                    parent: result.parent ?? null,
                    path: result.path ?? 'Root',
                    access: result.access ?? false,
                    edit: result.edit ?? false,
                    childs: Array.isArray(result.childs) ? result.childs : []
                })
            } else {
                setFolderData({ parent: null, path: 'Root', access: false, edit: false, childs: [] })
            }
        } catch (error: any) {
            console.log(error)
            if (error.code === "ERR_BAD_REQUEST") {
                logOut(dispatch)
            } else if (error.code === "ERR_NETWORK") {
                showSnackbar('ERROR NETWORK', 'error')
            }
            setFolderData({ parent: null, path: 'Root', access: false, edit: false, childs: [] })
        } finally {
            setLoading(false)
        }
    }

    useEffect(() => {
        // Пропускаем запрос если:
        // 1. Это первоначальная загрузка и у нас есть folder_id в URL
        if (isInitialUrlLoad && folder_id) {
            return
        }
        fetchData(currentFolderId)
        accesslevel === "5" && getPartners()
    }, [currentFolderId, isInitialUrlLoad, folder_id])

    const handleFolderClick = (item: any) => {
        setFolderHistory((prev) => [...prev, { id: currentFolderId, title: folderData?.path || 'Root' }])
        setCurrentFolderId(item.id)
    }

    const handleGoBack = () => {
        if (!folderHistory.length) {
            setCurrentFolderId(null)
            return
        }

        const previous = folderHistory[folderHistory.length - 1]
        setFolderHistory((prev) => prev.slice(0, -1))
        setCurrentFolderId(previous.id)
    }

    const handleParentUp = () => {
        if (folderData?.parent != null) {
            setCurrentFolderId(folderData.parent)
            setFolderHistory((prev) => prev.slice(0, -1))
        } else {
            handleGoBack()
        }
    }

    const handleOpenCreateFolder = () => {
        setNewFolder({ name: '', description: '', showsetuptopartner: '1', partner: null })
        setCreateFolderOpen(true)
    }

    const handleCloseCreateFolder = () => setCreateFolderOpen(false)

    const handleOpenEditFolder = async (item: any) => {
        setEditingFolderId(item.id)
        setEditFolderLoading(true)
        try {
            const response = await axios.get(`https://cardgarantsales.com/restapi/aifunctionsv2/${item.id}`, {
                headers: {
                    'Content-Type': 'application/json',
                    "Authorization": "Bearer " + localStorage.getItem('access_token')
                }
            })

            if (response.data) {
                setEditFolder({
                    name: response.data.name || '',
                    description: response.data.description || '',
                    path: response.data.path || '',
                    showsetuptopartner: response.data.showsetuptopartner == 0 ? '0' : '1',
                    partner: response.data.partner ?? null
                })
            }
            setEditFolderOpen(true)
        } catch (error: any) {
            console.log(error)
            showSnackbar && showSnackbar('ERROR LOADING FOLDER DATA', 'error')
        } finally {
            setEditFolderLoading(false)
        }
    }

    const handleCloseEditFolder = () => {
        setEditFolderOpen(false)
        setEditingFolderId(null)
        setEditFolder({ name: '', description: '', path: '', showsetuptopartner: '1', partner: null })
    }

    const handleUpdateFolder = async () => {
        if (!editFolder.name.trim()) return
        try {
            setEditFolderLoading(true)
            const response = await axios.put(`https://cardgarantsales.com/restapi/aifunctionsv2/${editingFolderId}`, {
                name: editFolder.name,
                type: 'folder',
                description: editFolder.description,
                path: editFolder.path,
                showsetuptopartner: editFolder.showsetuptopartner,
                partner: editFolder.partner
            }, {
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: 'Bearer ' + localStorage.getItem('access_token')
                }
            })
            handleCloseEditFolder()
            fetchData(currentFolderId)
        } catch (error: any) {
            console.log(error)
            showSnackbar && showSnackbar('ERROR UPDATING FOLDER', 'error')
        } finally {
            setEditFolderLoading(false)
        }
    }

    const handleCreateFolder = async () => {
        if (!newFolder.name.trim()) return
        try {
            setLoading(true)
            const response = await axios.post(`https://cardgarantsales.com/restapi/aifunctionsv2`, {
                name: newFolder.name,
                description: newFolder.description,
                parent: currentFolderId,
                type: 'folder',
                showsetuptopartner: newFolder.showsetuptopartner,
                partner: newFolder.partner
            }, {
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: 'Bearer ' + localStorage.getItem('access_token')
                }
            })
            handleCloseCreateFolder()
            fetchData(currentFolderId)
        } catch (error: any) {
            console.log(error)
            showSnackbar && showSnackbar('ERROR CREATING FOLDER', 'error')
        } finally {
            setLoading(false)
        }
    }

    const truncateText = (s: any, n: number) => {
        if (!s) return ''
        const str = String(s)
        return str.length > n ? str.slice(0, n) + '...' : str
    }

    const isMaskedFolderName = (name: any) => {
        if (name === null || name === undefined || name === '') return false
        const str = String(name).trim()
        return /^[XХ]{2,}$/.test(str)
    }

    const getFolderNameLabel = (name: any) => {
        if (name === null || name === undefined || name === '') return ''
        return String(name).trim()
    }

    const [deleteDialogOpen, setDeleteDialogOpen] = useState(false)
    const [deleteTarget, setDeleteTarget] = useState<any>(null)
    const [deleteConfirmText, setDeleteConfirmText] = useState('')
    const [deleteLoading, setDeleteLoading] = useState(false)

    const openDeleteDialog = (item: any) => {
        setDeleteTarget(item)
        setDeleteConfirmText('')
        setDeleteDialogOpen(true)
    }

    const closeDeleteDialog = () => {
        setDeleteTarget(null)
        setDeleteConfirmText('')
        setDeleteDialogOpen(false)
    }

    const handleConfirmDelete = async () => {
        if (deleteConfirmText.trim() === 'delete') {
            setDeleteLoading(true)
            try {
                const response = await axios.delete(`https://cardgarantsales.com/restapi/aifunctionsv2/${deleteTarget.id}`, {
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: 'Bearer ' + localStorage.getItem('access_token')
                    }
                })

                const responseMessage = response.data?.message || String(response.data) || ''
                if (responseMessage.includes('Folder must be empty')) {
                    showSnackbar && showSnackbar('Folder must be empty', 'error')
                } else {
                    showSnackbar && showSnackbar('Deleted successfully', 'success')
                    fetchData(currentFolderId)
                    closeDeleteDialog()
                }
            } catch (error: any) {
                console.log(error)
                const errorMessage = error.response?.data?.message || String(error.response?.data) || error.message || ''

                if (errorMessage.includes('Folder must be empty')) {
                    showSnackbar && showSnackbar('Folder must be empty', 'error')
                } else if (error.response?.status === 401) {
                    logOut(dispatch)
                } else if (error.code === "ERR_NETWORK") {
                    showSnackbar && showSnackbar('ERROR NETWORK', 'error')
                } else {
                    showSnackbar && showSnackbar('ERROR DELETING ITEM', 'error')
                }
            } finally {
                setDeleteLoading(false)
            }
        } else {
            showSnackbar && showSnackbar('Type "delete" to confirm', 'error')
        }
    }

    const handleEditFolder = (item: any) => {
        handleOpenEditFolder(item)
    }

    return (
        <Box sx={{ height: '86vh', display: 'flex', flexDirection: 'column', mr: 1, p: 1 }}>
            <Box sx={{ mb: 2, display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 1 }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, flexWrap: 'wrap' }}>
                    <Typography variant="body2" color="text.secondary">{folderData?.path || '/'}</Typography>
                    {/* <Breadcrumbs separator="›" aria-label="breadcrumb">
                        {(() => {
                            const crumbs = [
                                ...folderHistory.map((f) => ({ id: f.id, title: (f.title || 'Root').split('/').filter(Boolean).pop() || 'Root' })),
                                { id: currentFolderId, title: (folderData?.path || 'Root').split('/').filter(Boolean).pop() || 'Root' }
                            ]
                            return crumbs.map((c: any, idx: number) => {
                                const isLast = idx === crumbs.length - 1
                                return (
                                    <Typography
                                        key={`crumb-${idx}`}
                                        color={isLast ? 'text.primary' : 'text.secondary'}
                                        sx={{ maxWidth: 220, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', cursor: isLast ? 'default' : 'pointer' }}
                                        onClick={() => {
                                            if (!isLast) {
                                                // navigate directly to selected ancestor
                                                setCurrentFolderId(c.id)
                                                setFolderHistory((prev) => prev.slice(0, idx))
                                            }
                                        }}
                                    >
                                        {c.title}
                                    </Typography>
                                )
                            })
                        })()}
                    </Breadcrumbs> */}
                </Box>
                <Box sx={{ display: 'flex', gap: 1 }}>
                    {folderData?.edit && (
                        <>
                            <Button size="small" variant="contained" component={Link} to={`/function?folder_id=${currentFolderId || ''}&type=add`}>
                                <TranslatedText text="Create Function" />
                            </Button>
                            <Button size="small" variant="outlined" onClick={handleOpenCreateFolder}>
                                <TranslatedText text="Create Folder" />
                            </Button>
                        </>
                    )}
                    {/* <Button
                        startIcon={<ArrowBackIosNewIcon fontSize="small" />}
                        variant="outlined"
                        size="small"
                        disabled={!folderHistory.length && currentFolderId == null && folderData?.parent == null}
                        onClick={() => {
                            // Prefer direct parent id if available
                            if (folderData?.parent != null) {
                                setFolderHistory((prev) => prev.slice(0, -1))
                                setCurrentFolderId(folderData.parent)
                            } else {
                                handleGoBack()
                            }
                        }}
                    >
                        <TranslatedText text="Up" />
                    </Button> */}
                </Box>
            </Box>

            {loading ? (
                <LinearProgress sx={{ width: '100%', mt: 2 }} />
            ) : (
                <Box sx={{ flex: 1, overflowY: 'auto' }}>

                    <List disablePadding>
                        {(folderData?.parent != null || folderHistory.length > 0 || (startedFromUrl && currentFolderId != null)) && (
                            <ListItem disablePadding sx={{ width: '100%' }}>
                                <ListItemButton onClick={handleParentUp} sx={{ width: '100%', minHeight: 48, border: '1px solid rgba(0,0,0,0.06)', borderRadius: 1, my: 0.5, p: 1, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                    <ListItemIcon sx={{ minWidth: 36 }}>
                                        <ArrowBackIosNewIcon fontSize="small" color="action" />
                                    </ListItemIcon>
                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, width: '100%' }}>
                                        <Typography sx={{ color: 'text.secondary' }} variant='caption'>
                                            <TranslatedText text="Go back" />
                                        </Typography>
                                    </Box>
                                </ListItemButton>
                            </ListItem>
                        )}
                        {Array.isArray(folderData.childs) && folderData.childs.length ? (
                            folderData.childs.map((item: any) => (
                                <ListItem key={item.id} disablePadding sx={{ width: '100%' }}>
                                    {item.type === 'folder' ? (
                                        <ListItemButton onClick={() => handleFolderClick(item)} sx={{ width: '100%', minHeight: 48, border: '1px solid rgba(0,0,0,0.06)', borderRadius: 1, my: 0.5, p: 1, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                            <ListItemIcon sx={{ minWidth: 36 }}>
                                                <FolderOutlinedIcon color="primary" fontSize="small" />
                                            </ListItemIcon>
                                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, width: '100%' }}>
                                                <Typography sx={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', mr: 1, fontStyle: isMaskedFolderName(item.name) ? 'italic' : 'normal', color: isMaskedFolderName(item.name) ? 'text.secondary' : 'text.primary' }} variant='body2'>
                                                    {isMaskedFolderName(item.name)
                                                        ? <TranslatedText text='Folder name is hidden' />
                                                        : getFolderNameLabel(item.name) || `Folder ${item.id}`
                                                    }
                                                </Typography>

                                                <Typography sx={{ color: 'text.secondary' }} variant='caption'>
                                                    {truncateText(item.description, 100)}
                                                </Typography>
                                            </Box>
                                            <Box sx={{ display: 'flex', gap: 1 }}>
                                                {accesslevel == '5' && (
                                                    <Typography sx={{ color: 'text.secondary', width: '200px' }} variant='caption'>
                                                        <TranslatedText text='Available to partner' />: <br />{item['partner'] == null ? <TranslatedText text='Only for admin' /> : item['partner'] == 0 ? <TranslatedText text='All partners' /> : item['partnerbankcode']}
                                                    </Typography>
                                                )}
                                                {accesslevel == '5' && (
                                                    <Typography sx={{ color: 'text.secondary', width: '170px' }} variant='caption'>
                                                        <TranslatedText text='Settings' />: <br />{item['showsetuptopartner'] == '1' ? <TranslatedText text='Visible to partner' /> : <TranslatedText text='Hidden from partner' />}
                                                    </Typography>
                                                )}
                                                {item?.edit && (
                                                    <IconButton size="small" color="primary" onClick={(e) => { e.preventDefault(); e.stopPropagation(); handleEditFolder(item) }}>
                                                        <EditOutlinedIcon fontSize="small" />
                                                    </IconButton>
                                                )}
                                                {item?.edit && (
                                                    <IconButton size="small" color="error" onClick={(e) => { e.preventDefault(); e.stopPropagation(); openDeleteDialog(item) }}>
                                                        <DeleteOutlineIcon fontSize="small" />
                                                    </IconButton>
                                                )}
                                            </Box>
                                        </ListItemButton>
                                    ) : (
                                        <ListItemButton component={item?.edit ? Link : 'div'} to={item?.edit ? `/function?id=${item.id}&type=edit` : ''} sx={{ width: '100%', minHeight: 48, border: '1px solid rgba(0,0,0,0.04)', borderRadius: 1, my: 0.5, p: 1, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                            <ListItemIcon sx={{ minWidth: 36 }}>
                                                <FunctionsIcon color="action" fontSize="small" />
                                            </ListItemIcon>
                                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, width: '100%' }}>
                                                <Typography sx={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', mr: 1 }} variant='body2'>
                                                    {item.name || `Function ${item.id}`}
                                                </Typography>
                                                <Typography sx={{ color: 'text.secondary' }} variant='caption'>
                                                    {truncateText(item.description, 100)}
                                                </Typography>
                                            </Box>
                                            <Box sx={{ display: 'flex', gap: 1 }}>
                                                {accesslevel == '5' && (
                                                    <Typography sx={{ color: 'text.secondary', width: '200px' }} variant='caption'>
                                                        <TranslatedText text='Available to partner' />: <br />{item['partner'] == null ? <TranslatedText text='Only for admin' /> : item['partner'] == 0 ? <TranslatedText text='All partners' /> : item['partnerbankcode']}
                                                    </Typography>
                                                )}
                                                {accesslevel == '5' && (
                                                    <Typography sx={{ color: 'text.secondary', width: '170px' }} variant='caption'>
                                                        <TranslatedText text='Settings' />: <br />{item['showsetuptopartner'] == '1' ? <TranslatedText text='Visible to partner' /> : <TranslatedText text='Hidden from partner' />}
                                                    </Typography>
                                                )}
                                                {item?.edit && (
                                                    <IconButton sx={{ opacity: 0 }} size="small" color="primary" >
                                                        <EditOutlinedIcon fontSize="small" />
                                                    </IconButton>
                                                )}
                                                {item?.edit && (
                                                    <IconButton size="small" color="error" onClick={(e) => { e.preventDefault(); e.stopPropagation(); openDeleteDialog(item) }}>
                                                        <DeleteOutlineIcon fontSize="small" />
                                                    </IconButton>
                                                )}
                                            </Box>
                                        </ListItemButton>
                                    )}
                                </ListItem>
                            ))
                        ) : (
                            <ListItem disablePadding sx={{ width: '100%' }}>
                                <Typography color="text.secondary" sx={{ p: 2 }}><TranslatedText text="Folder is empty" /></Typography>
                            </ListItem>
                        )}
                    </List>

                </Box>
            )}

            <Dialog open={createFolderOpen} onClose={handleCloseCreateFolder}>
                <DialogTitle><TranslatedText text="Create Folder" /></DialogTitle>
                <DialogContent>
                    <TextField variant="outlined" size="small" autoFocus sx={{ mb: 2, mt: 2 }} label={<TranslatedText text="Folder name" />} fullWidth value={newFolder.name} onChange={(e) => setNewFolder({ ...newFolder, name: e.target.value })} />
                    <TextField variant="outlined" size="small" sx={{ mb: 2 }} label={<TranslatedText text="Description" />} fullWidth value={newFolder.description} onChange={(e) => setNewFolder({ ...newFolder, description: e.target.value })} />
                    {Number(accesslevel) === 5 &&
                        <>
                            <FormControl sx={{ mr: 2 }}>
                                <InputLabel size="small" id="simple-select-label"><TranslatedText text={'Partner'} /></InputLabel>
                                <Select sx={{ width: 223 }} labelId="simple-select-label" onChange={(e: any) => setNewFolder({ ...newFolder, partner: e.target.value !== '' ? e.target.value : null })} value={newFolder.partner} variant="outlined" size="small" label={<TranslatedText text={'Partner'} />} >
                                    <MenuItem>Only admin</MenuItem>
                                    <MenuItem value={0}>Any</MenuItem>
                                    {
                                        partners.map((el: any) => {
                                            //make partners list item
                                            return (
                                                <MenuItem key={el.id} value={el.id}>{el.partnerbankcode}</MenuItem>
                                            )
                                        })
                                    }
                                </Select>
                            </FormControl>
                        </>
                    }
                    {Number(accesslevel) === 5 && (
                        <FormControlLabel control={<Switch checked={newFolder.showsetuptopartner === '1'} onChange={(e) => setNewFolder({ ...newFolder, showsetuptopartner: e.target.checked ? '1' : '0' })} />} label={<TranslatedText text="Show setup to partner" />} />
                    )}
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCloseCreateFolder}><TranslatedText text="Cancel" /></Button>
                    <Button onClick={handleCreateFolder} variant="contained"><TranslatedText text="Create" /></Button>
                </DialogActions>
            </Dialog>
            <Dialog open={editFolderOpen} onClose={handleCloseEditFolder}>
                <DialogTitle><TranslatedText text="Edit Folder" /></DialogTitle>
                {editFolderLoading && <LinearProgress sx={{ width: '100%' }} />}
                <DialogContent>
                    <TextField variant="outlined" size="small" autoFocus sx={{ mb: 2, mt: 2 }} label={<TranslatedText text="Folder name" />} fullWidth value={editFolder.name} onChange={(e) => setEditFolder({ ...editFolder, name: e.target.value })} disabled={editFolderLoading} />
                    <TextField variant="outlined" size="small" sx={{ mb: 2 }} label={<TranslatedText text="Description" />} fullWidth value={editFolder.description} onChange={(e) => setEditFolder({ ...editFolder, description: e.target.value })} disabled={editFolderLoading} />
                    <TextField variant="outlined" size="small" sx={{ mb: 2 }} label={<TranslatedText text="Path" />} fullWidth value={editFolder.path} onChange={(e) => setEditFolder({ ...editFolder, path: e.target.value })} disabled={editFolderLoading} />
                    {Number(accesslevel) === 5 &&
                        <>
                            <FormControl sx={{ mr: 2 }} disabled={editFolderLoading}>
                                <InputLabel size="small" id="simple-select-label"><TranslatedText text={'Partner'} /></InputLabel>
                                <Select sx={{ width: 223 }} labelId="simple-select-label" onChange={(e: any) => setEditFolder({ ...editFolder, partner: e.target.value !== '' ? e.target.value : null })} value={editFolder.partner} variant="outlined" size="small" label={<TranslatedText text={'Partner'} />} >
                                    <MenuItem>Only admin</MenuItem>
                                    <MenuItem value={0}>Any</MenuItem>
                                    {
                                        partners.map((el: any) => {
                                            return (
                                                <MenuItem key={el.id} value={el.id}>{el.partnerbankcode}</MenuItem>
                                            )
                                        })
                                    }
                                </Select>
                            </FormControl>
                        </>
                    }
                    {Number(accesslevel) === 5 && (
                        <FormControlLabel control={<Switch checked={editFolder.showsetuptopartner === '1'} onChange={(e) => setEditFolder({ ...editFolder, showsetuptopartner: e.target.checked ? '1' : '0' })} disabled={editFolderLoading} />} label={<TranslatedText text="Show setup to partner" />} />
                    )}
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCloseEditFolder} disabled={editFolderLoading}><TranslatedText text="Cancel" /></Button>
                    <Button onClick={handleUpdateFolder} variant="contained" disabled={editFolderLoading}><TranslatedText text="Update" /></Button>
                </DialogActions>
            </Dialog>
            <Dialog open={deleteDialogOpen} onClose={closeDeleteDialog}>
                <DialogTitle><TranslatedText text="Delete" /></DialogTitle>
                {deleteLoading && <LinearProgress sx={{ width: '100%' }} />}
                <DialogContent>
                    <Typography><TranslatedText text="To confirm deletion of" /> "{deleteTarget?.name || deleteTarget?.id}", <TranslatedText text="type" /> "delete" <TranslatedText text="below" />.</Typography>
                    <TextField autoFocus margin="dense" label={<TranslatedText text="Type delete to confirm" />} fullWidth value={deleteConfirmText} onChange={(e) => setDeleteConfirmText(e.target.value)} disabled={deleteLoading} />
                </DialogContent>
                <DialogActions>
                    <Button onClick={closeDeleteDialog} disabled={deleteLoading}><TranslatedText text="Cancel" /></Button>
                    <Button onClick={handleConfirmDelete} variant="contained" disabled={deleteLoading}><TranslatedText text="Confirm" /></Button>
                </DialogActions>
            </Dialog>
        </Box>
    )
}
